var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_Dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16,20H15a4,4,0,0,1-4-4V13a4,4,0,0,1,4-4h1a4,4,0,0,1,4,4v3A4,4,0,0,1,16,20Zm-1-9a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h1a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2ZM5,20H4a4,4,0,0,1-4-4V14a4,4,0,0,1,4-4H5a4,4,0,0,1,4,4v2A4,4,0,0,1,5,20ZM4,12a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2H5a2,2,0,0,0,2-2V14a2,2,0,0,0-2-2ZM3.5,8A3.5,3.5,0,0,1,0,4.5v-1a3.5,3.5,0,1,1,7,0v1A3.5,3.5,0,0,1,3.5,8Zm0-6A1.5,1.5,0,0,0,2,3.5v1a1.5,1.5,0,1,0,3,0v-1A1.5,1.5,0,0,0,3.5,2Zm13,5h-4a3.5,3.5,0,1,1,0-7h4a3.5,3.5,0,0,1,0,7Zm-4-5a1.5,1.5,0,1,0,0,3h4a1.5,1.5,0,0,0,0-3Z",
    transform: "translate(2 2)",
    fill: "#92929d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytic);
export default __webpack_public_path__ + "static/media/analytic.3189f161.svg";
export { ForwardRef as ReactComponent };